var requestObject = null;
var lastCheckedSearch = null;
var queryChangeInterval = null;
var globalSearchInput = null;
var resourceLandingSearchInput = null;

$(document).ready(function () {

    globalSearchInput = $('#resultsSearch');
    resourceLandingSearchInput = $('#resourceSearch');

    $('.main-nav').multilevelNav({
        'hoverIntent': true,
        'hoverIntentTimeout': 300,
        'topLevelWholeLinkToggler': true,
        'toggleOnClickOnly': true,
        'menuCloseOnInPageAnchorClick': true,
        'keepMenuOpenOnFocusOut': false,
        // 'keepMenuOpenOnFocusOut': true,
    });

    // Speedbump
    $(function () {

        // Initialize speedbump
        $.fn.speedBumpModal({
            'speedBumpTitle': 'You\'re now leaving SELCO\'s site.',
            'speedBumpSummary': 'Thanks for visiting. Please note, SELCO isn\'t responsible for the overall content or any info you may share on the following site.',
            'speedBumpContinueLink': 'Continue to Site',
            'speedBumpCancelLink': 'Go Back',
            'speedBumpHeadingTag': '<h2 class="h4">',
            // 'speedBumpCloseIconClass': 'btn-close',
            'speedBumpIgnoreArray': safeListArray,
        });
    });

    // headroom
    const header = document.querySelector("header");

    const headroom = new Headroom(header, {
        offset: 100,
        tolerance: 10,
        onUnpin: function () {
            $('#searchCollapse').collapse('hide');
            // $('#loginCollapse').collapse('hide');
            if ($(window).width() > 992) {
                $('#loginCollapse').collapse('hide');
            }
        },
    });
    headroom.init();

    $('.glossary__alpha-nav-prev').on('click', moveGlossaryFilterRight);
    $('.glossary__alpha-nav-next').on('click', moveGlossaryFilterLeft);
    $('.glossary__alpha-nav-list-wrap').on('scroll', checkGlossaryFilterArrows);


    $('.eduction-filter').on('click', function(){

        var $activeFilter = $(this);
        var $listingRoot = $('#education-article-results-wrap');
        
        $.ajax({
            url: $('#educationCategoryDropdown').data('url'),
            contentType: "application/html; charset=utf-8",
            type: "GET",
            data: { cat: $activeFilter.data('value'), ajax: "true" },
            dataType: "html",
            cache: false,
            success: function (results, status) {
                var $content = $(results);
                $listingRoot.html($content);
            }
        });
    });

    $('.event-filter').on('click', function(){
        var $activeFilter = $(this);
        var $listingRoot = $('#event-listing-results-wrap');
        
        $.ajax({
            url: $('#eventsCategoryDropdown').data('url'),
            contentType: "application/html; charset=utf-8",
            type: "GET",
            data: { cat: $activeFilter.data('value'), ajax: "true" },
            dataType: "html",
            cache: false,
            success: function (results, status) {
                var $content = $(results);
                $listingRoot.html($content);
            }
        });
    });

    $('.region-filter').on('click', function(){
        var $activeFilter = $(this);
        
        if($activeFilter.data('value') == '0'){
            $(this).closest(".bio-grid-block").find('.bio-grid-item').each(function(){
                    $(this).show();
           });
        }
       else{
        $(this).closest(".bio-grid-block").find('.bio-grid-item').each(function(){
            var regions = $(this).data('regions');

            if(regions.includes($activeFilter.data('value'))){
                $(this).show();
            }
            else{
                $(this).hide();
            }
       });
       }
    });

    $('#chat-form').on('submit', function(e){
     
        e.preventDefault();
        var accountValid = false;
        var userValid = false;
        var reg = new RegExp('^[0-9]+$');

        var chat_user = $("#FullName").val();

        var chat_workgroup = $("#ChatQueue").val();

        
        var chat_acctnum = $("#AccountNumber").val();

        var window_url = 'https://chat.selco.org/WebChat/Start.html?' // default value to be over-written below


        window_url = window_url + "chatUsername=" + chat_user + "&";

        window_url = window_url + "interactionType=Chat&";

        window_url = window_url + "target=" + chat_workgroup + "&";

        window_url = window_url + "targetType=Workgroup" + "&";

        window_url = window_url + "chatAcctNum=" + chat_acctnum; //+ "&";

        if($("#AccountNumber").val() && !reg.test($("#AccountNumber").val()))
        {
            accountValid = false;
            $('#account_feedback').text("Please only use numbers.");
            $('#account_feedback').show();
        }
        else{
            $('#account_feedback').hide();
            accountValid = true;
        }

        if(!$("#FullName").val())
        {
            userValid = false;
            $('#name_feedback').text("Please enter a name.");
            $('#name_feedback').show();
        }
        else{
            $('#name_feedback').hide();
            userValid = true;
        }

        if(userValid && accountValid){
            window.open(window_url,"Selco Chat","width=700, height= 600");
        }
        
    });

    globalSearchInput.keyup(function () {

        clearInterval(queryChangeInterval);

        queryChangeInterval = setInterval(function () {
            clearInterval(queryChangeInterval);
            var currentSearch = globalSearchInput.val();
            if (currentSearch === lastCheckedSearch)
                return;

                console.log(currentSearch);
            lastCheckedSearch = currentSearch;
            if (requestObject != null) {
                requestObject.abort();
            }

            if (currentSearch.length < 4) {
                // Hide suggestion section
                $('#searchSuggestionActive').removeClass('active');
                return;
            }

            requestObject = $.ajax({
                url: '/find_v2/_autocomplete',
                method: 'GET',
                dataType: 'HTML',
                data: { prefix: currentSearch }
            }).done(function (data) {
                $('#search-suggestion-wrap').html("");
                var results = JSON.parse(data);
                $.map(results.hits, function (item)
                    {
                        $('#search-suggestion-wrap').append(
                        '<li class="search-suggestions__item">' +
                        '<a href="' + $('#search-input-form').data('suggest-url') + '?q=' + item.query + '">' + item.query + '</a>' +
                        '</li>'
                        )
                    });

                    if(results.hits.length !== 0){
                        console.log("hit");
                        console.log(results.hits.length);
                        $('#searchSuggestionActive').addClass('active');
                     }
                     else{
                        $('#searchSuggestionActive').removeClass('active');
                     }

            });

        }, 200);
    });

    resourceLandingSearchInput.keyup(function () {

        clearInterval(queryChangeInterval);

        queryChangeInterval = setInterval(function () {
            clearInterval(queryChangeInterval);
            var currentSearch = resourceLandingSearchInput.val();
            if (currentSearch === lastCheckedSearch)
                return;

            lastCheckedSearch = currentSearch;
            if (requestObject != null) {
                requestObject.abort();
            }

            if (currentSearch.length < 4) {
                // Hide suggestion section
                $('#searchSuggestionActive').removeClass('active');
                return;
            }

            requestObject = $.ajax({
                url: '/find_v2/_autocomplete',
                method: 'GET',
                dataType: 'HTML',
                data: { prefix: currentSearch }
            }).done(function (data) {
                $('#search-suggestion-wrap').html("");
                var results = JSON.parse(data);
                $.map(results.hits, function (item)
                    {
                        $('#search-suggestion-wrap').append(
                        '<li class="search-suggestions__item">' +
                        '<a href="' + $('#resourceLandingForm').data('suggest-url') + '?q=' + item.query + '">' + item.query + '</a>' +
                        '</li>'
                        )

                        if(!$('#searchSuggestionActive').hasClass("active"))
                        {
                            $('#searchSuggestionActive').addClass('active');
                        }
                    });

                    if(results.hits.length === 0){
                        $('#searchSuggestionActive').removeClass('active');
                     }

            });

        }, 200);
    });

    // close mega menu when search is clicked
    $('#searchToggle').on('click', function () {
        if ($(window).width() > 992) {
            $('.mln__toggle-link[aria-expanded="true"]').trigger('click'); //close mega menus if open
            $('#headerSearchInput').focus();
        }
    });

    // close login collapse if clicking outside it
    $(document).mouseup(function (e) {
        if (!$(e.target).is('.login-menu__collapse, .login-menu__collapse *')) {
            $("#loginCollapse").collapse('hide');
        }
    });

    // close search collapse if clicking outside it
    $(document).mouseup(function (e) {
        if (!$(e.target).is('.desktop-search__collapse, .desktop-search__collapse *')) {
            $("#searchCollapse").collapse('hide');
        }
    });



    // single click card
    $(function () {

        // Clickable CTAs
        $('.single-click').each(function () {
            var $this = $(this),
                imgLink = $this.find('a img'),
                down,
                up,
                link = $this.find('a'),
                middleClick,
                auxClick;

            if (imgLink.length && link.length > 1) {
                imgLink.closest('a')
                .find('> *')
                .first()
                .unwrap();

            }

            if (!link.length) {
                $this.removeClass('clickable');
            }

            $this.on('mousedown', function (e) {
                down = + new Date();
                middleClick = (e.which === 2) ? true : false;
                auxClick = (e.which === 3) ? true : false;
            }).on('mouseup', function () {
                up = +new Date();

                if ((up - down) < 200 && auxClick === false) {
                    link[0].click();
                }
            });
        });
    });

    $('.filter-dropdown').each(function (key, dropdown) {
        var $dropdown = $(dropdown);
        $dropdown.find('.dropdown-toggle').text($dropdown.find('.active').text());

        $dropdown.find('.dropdown-menu button').on('click', function () {
            $dropdown.find('.active').removeClass('active');
            $(this).addClass('active');
            $dropdown.find('.dropdown-toggle').text($(this).text());
        });
    });

    // Glossary A-Z nav
    var scrollPosition;

    function moveGlossaryFilterRight() {
        $('.glossary__alpha-nav-next').removeClass('disabled');
        var alphaContainerWidth = $('.glossary__alpha-nav-list-wrap').width();
        var alphaWidth = $('.glossary__alpha-nav-list-wrap ol').width();
        var alphaRatio = alphaWidth / alphaContainerWidth;
        if (alphaRatio < 2) {
            scrollPosition = 0;
        } else {
            scrollPosition = $('.glossary__alpha-nav-list-wrap')[0].scrollLeft - alphaContainerWidth + 40;
            if (scrollPosition < 0) {
                scrollPosition = 0;
            }
        }

        if (scrollPosition === 0) {
            $('.glossary__alpha-nav-prev').addClass('disabled');
        }

        $('.glossary__alpha-nav-list-wrap').animate({ scrollLeft: scrollPosition }, 500);
    }

    function moveGlossaryFilterLeft() {
        $('.glossary__alpha-nav-prev').removeClass('disabled');
        var alphaContainerWidth = $('.glossary__alpha-nav-list-wrap').width();
        var alphaWidth = $('.glossary__alpha-nav-list-wrap ol').width();
        var alphaRatio = alphaWidth / alphaContainerWidth;
        var maxScroll = (alphaWidth - alphaContainerWidth);

        if (alphaRatio < 2) {
            scrollPosition = maxScroll;
        } else {
            scrollPosition = alphaContainerWidth + $('.glossary__alpha-nav-list-wrap')[0].scrollLeft - 40;
            if (maxScroll < scrollPosition) {
                scrollPosition = maxScroll;
            }
        }

        if (scrollPosition === maxScroll) {
            $('.glossary__alpha-nav-next').addClass('disabled');
        }

        $('.glossary__alpha-nav-list-wrap').animate({ scrollLeft: scrollPosition }, 500);
    }

    function checkGlossaryFilterArrows() {
        var alphaScrollLeft = $('.glossary__alpha-nav-list-wrap')[0].scrollLeft;

        if (alphaScrollLeft === 0) {
            $('.glossary__alpha-nav-prev').addClass('disabled');
        } else {
            $('.glossary__alpha-nav-prev').removeClass('disabled');
        }

        var alphaNavContainerLeft = Math.round($('.glossary__alpha-nav-list-wrap').offset().left + $('.glossary__alpha-nav-list-wrap').width());
        var alphaNavContainer = Math.round($('.glossary__alpha-nav-list-wrap ol').offset().left + $('.glossary__alpha-nav-list-wrap ol').width());

        console.log(alphaNavContainerLeft);
        console.log(alphaNavContainer);

        if (alphaNavContainerLeft === alphaNavContainer) {
            $('.glossary__alpha-nav-next').addClass('disabled');
        } else {
            $('.glossary__alpha-nav-next').removeClass('disabled');
        }
    }

    // Location Search Page ATM Toggle Switch
    $("#atmToggle").on("click", function () {
        if ($(this).attr('aria-checked') === 'false') {
            $(this).attr('aria-checked', 'true');
        } else {
            $(this).attr('aria-checked', 'false');
        }
    });

    var newDate = new Date();
    var currentDay = newDate.getDay();

    currentDay = currentDay > 0 ? currentDay - 1 : 6; // zero is sunday, not monday in javascript

    $('.lobby-hours-item-js').eq(currentDay).addClass('current-day');
    $('.drive-up-hours-item-js').eq(currentDay).addClass('current-day');

    
    // Hide search suggestions if clicking outside
    $(document).ready(function () {
    	window.addEventListener('click', function (event) {
    		if (!elementOrAncestorHasClass(event.target, 'search-results__search-wrap')) {
    				$('.search-suggestions').addClass('d-none');
    		}
    	});
    });

    // // step through search suggestions options with up/down arrow keys

    // Assign data-tab-index attr on the fly
    function assignDataIndex(el) {
        $(el).find('a').each(function (index) {
            $(this)
                .removeAttr('data-tab-index')
                .attr('data-tab-index', index);
        });
    }

    $('.search-results__bar').each(function () {
        var $globalSearch = $(this);
        var searchPageInput = $('#resultsSearch');
        // Give search input the lowest value
        searchPageInput.attr('data-tab-index', '-1');
        // Dynamically change the data tab index value as the user types
        $('#resultsSearch').on('keydown', function (e) {
            assignDataIndex($globalSearch);
        });
        // Make arrow up/down keys tab through the entries
        $globalSearch.on('keydown', function (e) {
            var $this = $(this);
            var keyPressed = e.which;
            var currentFocusData = $(':focus').data('tab-index');
            // Down arrow
            if (keyPressed === 40) {
                e.preventDefault();
                $this
                    .find($('[data-tab-index=' + (currentFocusData + 1) + ']'))
                    .focus();
            }
            // Up arrow
            if (keyPressed === 38) {
                e.preventDefault();
                $this
                    .find($('[data-tab-index=' + (currentFocusData - 1) + ']'))
                    .focus();
            }
        });
    });

    function elementOrAncestorHasClass(element, className) {
        if (!element || element.length == 0) {
            return false;
        }
        var parent = element;
        do {
            if (parent === document) {
                break;
            }
            if (parent.className.toString().indexOf(className) >= 0) {
                return true;
            }
        } while (parent = parent.parentNode);
        return false;
    }

    // Cache compare table element
    var compareTable = $('.product-comparison-block__table--mobile-wrap');

    // Setup compare table(s). Can have multiple on a page
    compareTable.each(function () {
        var $thisCompareTable = $(this);

        // Inital cell count var
        var cellColumnCount = null;

        // Add some unique identifiers to the table cells associated with the column they are in
        $thisCompareTable.find('tr').each(function (index) {
            var $tableRow = $(this);

            // Add class to fixed column cells
            $tableRow
                .find(' > *')
                .first()
                .addClass('cell-fixed');

            // Add data index to all of the cells
            $tableRow
                .find(' > *')
                .each(function (index) {
                    $(this).attr('data-cell-index', index);
                });

            // Add visible class to first column cells
            $tableRow
                .find('[data-cell-index="1"]')
                .addClass('cell-visible');

            // Define cell count var
            cellColumnCount = $tableRow.find(' > *').length;
        });

        var chevronSVG = $(`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"/></svg>
        `)

        // Build navigation to populate later
        $('<div>')
            .addClass('compare-table__nav')
            .append('<ul class="compare-table__nav-list">')
            .prepend('<button class="compare-table__prev" type="button" aria-label="previous"></button>')
            .append('<button class="compare-table__next" type="button" aria-label="next">')
            .appendTo($thisCompareTable);

        $thisCompareTable
            .find('.compare-table__prev, .compare-table__next')
            .append(chevronSVG.clone())

        // Cache nav
        var tableNav = $thisCompareTable.find('.compare-table__nav');

        // Add navigation item to table nav
        $thisCompareTable
            .find('tr')
            .first()
            .find(' > *')
            .each(function (index) {
                $('<li><button type="button" data-nav-associated-column="' + (index + 1) + '"><span class="visually-hidden">View column ' + (index + 2) + '</span></button></li>')
                    .appendTo(tableNav.find('ul'));
            });


        $thisCompareTable.each(() => {
            var $table = $(this);

            $table
                .find('.compare-table__prev, .compare-table__next')
                .on('click',(e) => {

                if( $(e.target).is('.compare-table__next') ){
                    $table.find('[data-nav-associated-column].active')
                        .parent()
                        .next()
                        .find('button')
                        .trigger('click')
                }
                if( $(e.target).is('.compare-table__prev') ){
                    $table.find('[data-nav-associated-column].active')
                        .parent()
                        .prev()
                        .find('button')
                        .trigger('click')
                }
    
                    // $('.compare-table__nav-list').animate({scrollLeft:  $('[data-nav-associated-column].active').position().left}, 500);
                    $table[0].querySelector('[data-nav-associated-column].active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
            })
            
        })



       

        // Remove first nav item since that column is static
        tableNav
            .find('li')
            .last()
            .remove();

        // Add active class to first nav item
        tableNav
            .find('li')
            .first()
            .find('button')
            .addClass('active');

        // Show/hide correct rows when nav item is clicked
        $thisCompareTable.find('[data-nav-associated-column]').on('click', function () {
            var currentNavIndex = $(this).data('nav-associated-column');

            tableNav
                .find('.active')
                .removeClass('active');

            $(this).addClass('active');

            $thisCompareTable
                .find('.cell-visible')
                .removeClass('cell-visible')
                .end()
                .find('[data-cell-index="' + currentNavIndex + '"]')
                .addClass('cell-visible');
        });
    });

    // Hide alert bar until the next session
    $('.alert-bar').each(function () {
        var $alert = $(this);
        var alertID = $alert.attr('id');

        $alert.on('hidden.bs.collapse', function () {
            sessionStorage.setItem('hideAlert-' + alertID + '', 'true');
        });

        if (sessionStorage.getItem('hideAlert-' + alertID + '') !== 'true') {
            $alert.addClass('show');
        }
    });

    $('a[href*="open-chat"]').click(function(e) {
        e.preventDefault(); 
        window.postMessage({ type: "TRIGGER_DIRECT_SECURE_CHAT"}, '*');
    });
    
    $('#email-us-form').submit(function(e) {
        e.preventDefault();
        var data = $('#email-us-form').serialize();
        $.ajax({
            url: '/formsubmissionapi/emailformsubmission',
            type: 'post',
            data: data,
            success: function () {
                $('#email-us-form').hide();
                $('.email-us-success').show();
            }
        }).fail(function(){
            $('.email-us-failure').show();
        }).always(function(){
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

    });

    $('.email-us-radio').on("click", function(){
        var subjectSelect = $(this).data("subject");
        var subjectOptions = document.querySelectorAll('[data-regarding]');
        var subjectOptionsToShow = document.querySelectorAll(`[data-regarding='${subjectSelect}']`);

        subjectOptions.forEach(function (option) {
            option.style.display = "none";
        });

        subjectOptionsToShow.forEach(function (option) {
            option.style.display = "block";
        });
    });

    $('#limit-sharing-info-form').submit(function(e) {
        e.preventDefault();
        var data = $('#limit-sharing-info-form').serialize();
        $.ajax({
            url: '/formsubmissionapi/limitsharingformsubmission',
            type: 'post',
            data: data,
            success: function () {
                $('#limit-sharing-info-form').hide();
                $('.limit-sharing-info-success').show();
            }
        }).fail(function(){
            $('.limit-sharing-info-failure').show();            
        }).always(function(){
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
});

// ****************************
// Run On Window Resize
// ****************************

// Set viewport function
function viewport() {
    var view = window;
    var viewString = 'inner';

    if (!('innerWidth' in window)) {
        viewString = 'client';
        view = document.documentElement || document.body;
    }

    return {
        width: view[viewString + 'Width'],
        height: view[viewString + 'Height']
    };
}

// Toggle location of utility nav in the DOM depending on screen size
function toggleDomLocation(el, containerSm, containerLg, breakpoint) {
    let $window = $(window);
    $(el).each(function () {
        var $this = $(this);
        if (viewport().width < breakpoint) {
            $this.appendTo($(containerSm));
        } else {
            $this.appendTo($(containerLg));
        }
        var windowWidth = $window.width();
        $window.on('resize', function () {
            var newWindowWidth = $window.width();

            if (windowWidth !== newWindowWidth) {
                if (viewport().width < breakpoint) {
                    $this.appendTo($(containerSm));
                } else {
                    $this.appendTo($(containerLg));
                }
            }

            windowWidth = newWindowWidth;
        });
    });
}

// Toggle location of login toggle in the DOM depending on screen size
toggleDomLocation('.login-menu', '.login-menu-mobile-wrap', '.login-menu-desktop-wrap', 992);

// Toggle location of utility nav in the DOM depending on screen size
toggleDomLocation('.utility-nav', '.utility-nav-mobile-wrap', '.utility-nav-desktop-wrap', 992);

// Toggle location of main nav search in the DOM depending on screen size
toggleDomLocation('.nav-search__form', '.search-mobile', '.search-desktop', 992);

// Toggle location of footer social profile links in the DOM depending on screen size
toggleDomLocation('.social-profile-list', '.mobile-social-list-wrap', '.desktop-social-list-wrap', 992);

// Toggle location of footer social profile links in the DOM depending on screen size
toggleDomLocation('.search-results__help-icons', '.help-icons-mobile-js', '.help-icons-desktop-js', 992);

function ExecuteAjax(url, args, callback) {
	$.ajax({
		url: url,
		contentType: "application/html; charset=utf-8",
		type: "GET",
		data: args,
		dataType: "html",
		cache: false,
		success: function (results, status) {
			callback(results, status);
		}
	});
}

//Product Benefit Slider block

    // Force all cards to same height for vertical scroll on mobile
const mediaQueryCondition = window.matchMedia( '( max-width: 767px )' )

if ( mediaQueryCondition.matches ) {
    const elementsToMatch = document.querySelectorAll('.card-slider-mobile'); 
    matchHeight(elementsToMatch); 

    function matchHeight(elements) {
        let maxHeight = 0;
    
        // Find the tallest element
        elements.forEach(element => {
        const elementHeight = element.offsetHeight;
        if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
        }
        });
    
        // Set the height of all elements to the tallest height
        elements.forEach(element => {
        element.style.height = maxHeight + 'px';
        });
    }
}

const productBenefitSliderEl = document.querySelectorAll('.product-benefit-slider-block');

productBenefitSliderEl.forEach(block => {
        //Adds the top right card number to each card
    const productBenefitCards = block.querySelectorAll('.product-benefit-slider__card');
    const productBenefitCardArr = Array.from(productBenefitCards);
    const productSliderList = block.querySelector('.product-slider-list');

    productBenefitCardArr.forEach((card, index) => {
        const newDiv = document.createElement('div');
        newDiv.classList.add('product-benefit-slider__card-count');
        newDiv.innerHTML = ` <p class="product-benefit-slider__number"> ${index + 1}/${productBenefitCardArr.length}</p>`;
        productBenefitCards[index].prepend(newDiv);

        const createSliderDot = document.createElement('li');
        createSliderDot.classList.add('product-slider__dot')
        productSliderList.appendChild(createSliderDot);
    });

})


// Add gradient fade on scroll
const horizontalScrollFade = (el) => {
    const scrollLeft = el.scrollLeft;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;

    if (scrollLeft > 5) {
        el.classList.add('scrolled');
    } else {
        el.classList.remove('scrolled');
    }

    if (scrollLeft >= maxScrollLeft - 5) {
        el.classList.add('end-scrolled');
    } else {
        el.classList.remove('end-scrolled');
    }
}



const scrollableNav = document.querySelectorAll('.product-benefit-slider__cards-wrapper');
let scheduledAnimationFrame;
scrollableNav.forEach(item => {
    item.addEventListener('scroll', () => {
        if (!scheduledAnimationFrame) {
            scheduledAnimationFrame = true;

            requestAnimationFrame(() => {
                scheduledAnimationFrame = false;
                horizontalScrollFade(item);
            });
        }
    });
});

scrollableNav.forEach(scrollItem => {
    const scrollableNavContainer = scrollItem.closest('.product-benefit-slider__content-wrap');
    const items = Array.from(scrollItem.querySelectorAll('.product-benefit-slider__card'));
    const overflowThreshhold = 50;

    // Helper function to check if an item is fully in view
    const isFullyInView = (item, scrollItem) => {
        const containerRect = scrollItem.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        
        return (itemRect.left + overflowThreshhold) >= containerRect.left && itemRect.right <= (containerRect.right  + overflowThreshhold);
    };

    // Function to get the index of fully visible items
    const getFullyVisibleItemIndexes = () => {
        return items
            .map((item, index) => (isFullyInView(item, scrollItem) ? index : -1))
            .filter(index => index !== -1);
    };

    // Debounce function to check if scrolling has finished
    let scrollTimeout;
    const productDots = scrollableNavContainer.querySelectorAll('.product-slider__dot');
    
    scrollItem.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            applyDotClass();

        }, 100); // Adjust timeout duration as needed
    });

    applyDotClass();

    function applyDotClass() {
        const visibleIndexes = getFullyVisibleItemIndexes();
        
        productDots.forEach(item => {
            item.classList.remove('active');
        });

        visibleIndexes.forEach(item => {
            productDots[item].classList.add('active');
        });
    }

    const prevButton = scrollableNavContainer.querySelector('.slider-btn-left');
    const nextButton = scrollableNavContainer.querySelector('.slider-btn-right');

    nextButton.addEventListener('click', () => {
        const scrollAmount = scrollItem.querySelectorAll('.product-benefit-slider__card')[0].getBoundingClientRect().width + 20;
        scrollItem.scrollBy({ left: scrollAmount, behavior: 'smooth'});
    });

    prevButton.addEventListener('click', () => {
        const scrollAmount = scrollItem.querySelectorAll('.product-benefit-slider__card')[0].getBoundingClientRect().width + 20;
        scrollItem.scrollBy({ left: -scrollAmount, behavior: 'smooth'});
    });
});







document.addEventListener('DOMContentLoaded', () => {
    checkNavOverflow(scrollableNav)
})


window.addEventListener('resize', () => {
    checkNavOverflow(scrollableNav)
})

function checkNavOverflow(el) {
    el.forEach(item => {
        if (isOverflown(item)) {
            item.classList.add('js-is-overflown');
        } else {
            item.classList.remove('js-is-overflown');
        }
    })
}

function isOverflown({ clientWidth, clientHeight, scrollWidth, scrollHeight }) {
    return scrollHeight > clientHeight || scrollWidth > clientWidth;
}

//END JS for Product Benefit Slider block

// RUN GIF ANIMATIONS AGAIN WHEN SCROLLED INTO VIEWPORT

var images = document.getElementsByTagName('img');
var gifElements = [];

// Loop through the images on the page to see if any are gifs (contain '.gif' in src attribute).
for (var i = 0; i < images.length; i++) {
    if (!!(images[i].src).match(/\w+\.(gif)$/gi)) {
        gifElements.push(images[i]);
    }
}

if (gifElements.length) {
    // The callback function that will be fired when the gif apears in the viewport.
    function intersectionCallback (entries)
    {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Re-set the src attribute for the gif to restart the animation.
                entry.target.src = entry.target.src;
            }
        });
    }

    // Instantiate a new IntersectionObserver to fire when this gif is 50% visible (originally 75% but large images on small screens may never be 75% visible so reduced to 50%).
    let intersectionObserver = new IntersectionObserver(intersectionCallback, {
        threshold: [0.5]
    });

    // Loop through all gifs on the page to add the observer.
    for (let element of gifElements) {
        intersectionObserver.observe(element);
    }
}